// 解决 IE 特定问题
if (typeof window !== 'undefined') {
    // 解决 IE11 中 SVG 图标不显示问题
    require('core-js/features/object/assign')
    require('core-js/features/promise')

    // 解决 requestAnimationFrame 缺失
    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = cb => setTimeout(cb, 0)
    }
  }